<template>
    <kt-row>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="merchant_number">
                    {{ $t('label.merchant_number') }}
                </kt-form-label>
                <kt-form-control
                        id="merchant_number"
                        name="merchant_number"
                        v-model="form_data.merchant_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="terminal_number">
                    {{ $t('label.terminal_number') }}
                </kt-form-label>
                <kt-form-control
                        id="terminal_number"
                        name="terminal_number"
                        v-model="form_data.terminal_number"
                        class="form-control"
                ></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col lg="4" md="6" sm="12">
            <kt-form-group>
                <kt-form-label for="certificate">
                    {{ $t('label.certificate') }}
                </kt-form-label>
                <kt-form-label for="certificate" class="d-block btn btn-secondary btn-wide label-file">
                    <kt-icon type="fa" name="paperclip"></kt-icon>
                    {{ $t('btn.select_cert_file') }}
                </kt-form-label>
                <input
                        @change="processCertFile"
                        type="file"
                        class="custom-file-upload"
                        name="certificate"
                        id="certificate"
                        accept="text/xml"
                />
            </kt-form-group>
        </kt-col>
    </kt-row>
</template>

<script>
export default {
    props: {
        form_data: {
            required: true
        },
        port_config: {
            required: true
        }
    },
    methods:{
        processCertFile(e){
            this.form_data.certificate = event.target.files[0]
        },
    },
}
</script>

<style scoped>
    .label-file {
        border: 1px solid #ccc;
        width: fit-content;
        cursor: pointer;
        min-width: 200px;
    }
    input[type="file"]::-webkit-file-upload-button {
        visibility: hidden;
    }
</style>